import React, { Component } from 'react'
import StaffPicture from './StaffPicture/StaffPicture'

class BookingFormHeader extends Component {
  render() {
    const { business, fields } = this.props
    const staffField = fields.find(f => f.id === 'booking_staff')

    return (
      <div>
        <StaffPicture business={business} staffField={staffField} />
      </div>
    );
  }
}

export default BookingFormHeader
